<template>
 <div>
    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item active"><i class="fa fa-files-o"></i> JSA Templates</li>
            <li class="ml-3">
                <router-link :to="`/jsa/templates/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create JSA Template</router-link>
            </li>
        </ol>
    </h4>

    <div class="card">
        <div class="card-body">
           <v-server-table url="/jsa/templates/list" :columns="columns" :options="options">

               <template slot="jsa_id" slot-scope="props">
                   <router-link :to="`/jsa/templates/view/${props.row.jsa_id}`" title="View" class="btn btn-xs btn-secondary">
                       View
                   </router-link>

                    <router-link :to="`/jsa/templates/edit/${props.row.jsa_id}`" title="View" class="btn btn-xs btn-light">
                       <i class="fa fa-edit"></i> Edit
                   </router-link>
               </template>

               <router-link slot="jsa_name" slot-scope="props" :to="`/jsa/templates/view/${props.row.jsa_id}`">
                   {{ props.row.jsa_name }}
               </router-link>

               <template slot="jsa_steps" slot-scope="props">
                {{ props.row.jsa_steps != null ? (JSON.parse(props.row.jsa_steps)).length : 0 }}
               </template>

               <template slot="is_active" slot-scope="props">
                 <span class="badge badge-success" v-if="props.row.is_active == 1">Active</span>
                 <span class="badge badge-warning" v-else>Inactive</span>
               </template>

               <template slot="updated_at" slot-scope="props">
                   {{ props.row.updated_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
               </template>

           </v-server-table>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['jsa_id', 'jsa_name', 'jsa_steps', 'is_active', 'updated_at'],
                options: {
                    headings: {
                        jsa_id: 'View',
                        jsa_name: 'Name',
                        jsa_steps: '# of Steps',
                        is_active: 'Active',
                        updated_at: 'Last Updated',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'jsa_id',
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'jsa_records.jsa_id',
                },
            }
        },

        computed: {

        },

        methods: {

        },

        mounted(){

        },
    }
</script>
